import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

export default function ScenariosSection() {
  const { t } = useTranslation();

  const scenarios = [
    { icon: 'ri-quill-pen-line', title: t('scenario_1'), color: 'bg-blue-50', iconColor: 'text-blue-600' },
    { icon: 'ri-award-line', title: t('scenario_2'), color: 'bg-purple-50', iconColor: 'text-purple-600' },
    { icon: 'ri-gallery-line', title: t('scenario_3'), color: 'bg-teal-50', iconColor: 'text-teal-600' },
    { icon: 'ri-file-shield-line', title: t('scenario_4'), color: 'bg-orange-50', iconColor: 'text-orange-600' },
    { icon: 'ri-user-voice-line', title: t('scenario_5'), color: 'bg-pink-50', iconColor: 'text-pink-600' },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-5xl font-bold text-neutral-dark mb-4">
            {t('scenarios_title')}
          </h2>
          <p className="text-xl text-neutral-text">
            {t('scenarios_subtitle')}
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
          {scenarios.map((scenario, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
              whileHover={{ scale: 1.05, y: -5 }}
              className="flex flex-col items-center text-center cursor-pointer"
            >
              <div className={`w-32 h-32 ${scenario.color} rounded-full flex items-center justify-center mb-4 shadow-lg`}>
                <i className={`${scenario.icon} text-5xl ${scenario.iconColor}`}></i>
              </div>
              <h3 className="text-lg font-semibold text-neutral-dark">
                {scenario.title}
              </h3>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
